import { combineReducers } from 'redux';
import { loginReducer } from './login';
import keycloakReducer from './keycloak';
import userList from './userList';
import userProfileData from './userProfileData';

export const rootReducer = combineReducers({
    loginReducer: loginReducer,
    keycloak: keycloakReducer,
    userList: userList,
    userProfileData: userProfileData
});



// WEBPACK FOOTER //
// ./src/reducers/index.js